import { render, staticRenderFns } from "./DataCategory1.vue?vue&type=template&id=5d309b7f"
import script from "./DataCategory1.vue?vue&type=script&lang=js"
export * from "./DataCategory1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports